var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerGmaps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    viewBox: "0 0 788 384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#04a995;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "73 35 31 92 16 161 60 251 144 364 193.13 303.88 209.85 279.98 271 159 271 86 230 41 161 16 73 35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M209.85,280A16,16,0,0,0,232,275.27C269.16,218,288,173.86,288,144,288,64.6,223.4,0,144,0S0,64.6,0,144c0,74.38,118.24,218.11,131.72,234.26A16,16,0,0,0,144,384h0a16,16,0,0,0,12.27-5.73c.74-.88,18.19-21.79,40.32-52a16,16,0,1,0-25.83-18.91c-10.39,14.2-19.82,26.4-26.81,35.23C104.14,292.43,32,191.71,32,144a112,112,0,0,1,224,0c0,22.91-18.06,63.34-50.86,113.85A16,16,0,0,0,209.85,280Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M209.68,119.66a9.17,9.17,0,0,0-.24-1.53,4,4,0,0,0-2.38-2.87,4.16,4.16,0,0,0-3.34,0,14.26,14.26,0,0,0-2.61,1.51,84.7,84.7,0,0,1-11.33,6.5l-.08,0-.16.07v0a5.87,5.87,0,0,0-3.4,5.31,4.89,4.89,0,0,0,.07.68v.06c4.91,36.49-7.06,51.28-9.82,55.22-4.83,6.9-11,9.46-18.92,8.13a10.81,10.81,0,0,1-1.68-.44.78.78,0,0,1-.35-1.24c3.21-3.84,15.88-21.4,14-55.65-.48-8.83-2.92-13.6-5.62-15.77s-10.49-7.44-19.86-7.45-17.27,5.36-19.86,7.45-5.14,6.94-5.62,15.77c-1.84,34.25,10.83,51.81,14,55.65a.78.78,0,0,1-.35,1.24,10.81,10.81,0,0,1-1.68.44c-7.9,1.33-14.09-1.23-18.92-8.13-2.76-3.94-14.73-18.73-9.82-55.22v-.06a4.89,4.89,0,0,0,.07-.68,5.87,5.87,0,0,0-3.4-5.31v0l-.16-.07-.08,0a84.7,84.7,0,0,1-11.33-6.5,14.26,14.26,0,0,0-2.61-1.51,4.16,4.16,0,0,0-3.34,0,4,4,0,0,0-2.38,2.87,9.17,9.17,0,0,0-.24,1.53c-1.47,20.08,6.87,45.81,16.52,60.68a32.61,32.61,0,0,0,16.68,13.26,33,33,0,0,0,22.76-.37.81.81,0,0,1,.78.12c3,2.42,5.41,3.42,8.94,3.44s5.91-1,8.94-3.44a.81.81,0,0,1,.78-.12,32.68,32.68,0,0,0,39.44-12.89C202.81,165.47,211.15,139.74,209.68,119.66Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerGmaps);
export default __webpack_public_path__ + "static/media/marker-gmaps.9dba70e68171df12f95c35edf0772c3b.svg";
export { ForwardRef as ReactComponent };